import { NavLink, Paper } from "@mantine/core";
import { Link } from "react-router-dom";

const SideBar = ({ setOpened, links }) => {
  console.log("these are the links my boy", links);
  const items = links.map((item, index) => (
    <NavLink
      styles={{
        label: { fontSize: "1rem", color: "white" },
        root: {
          ":hover": { backgroundColor: "#D74D48" },
        },
      }}
      p="sm"
      // mt="md"
      key={item.label}
      label={index + 1 + " - " + item.label}
      // icon={item?.icon}
      component={Link}
      to={item.link}
      onClick={() => {
        setOpened(false);
      }}
    ></NavLink>
  ));

  return (
    <Paper
      style={{
        backgroundColor: "transparent",
      }}
      mt="xl"
    >
      {items}
    </Paper>
  );
};

export default SideBar;
